"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("@lsg/components");

var components_2 = require("@lsg/components");

var components_3 = require("@lsg/components");

var Paragraph_1 = require("@lsg/components/lib/components/atoms/Paragraph/Paragraph");

var Button_1 = require("@lsg/components/lib/components/atoms/Button/Button");

var react_components_1 = require("@lws/react-components");

exports.CardComponent = function (_a) {
  var data = _a.data;
  var title = data.text('title');
  var label = data.text('label');
  var description = data.longText('description');
  var ctaText = data.text('ctaText');
  var image = data.asset('image');
  var linkUrl = data.field('link').text('url');
  return react_1["default"].createElement(exports.CardWrapper, null, react_1["default"].createElement(exports.CardHeader, null, react_1["default"].createElement(react_components_1.BackgroundImage, {
    data: image
  }, react_1["default"].createElement(exports.BackgroundOverlay, null, react_1["default"].createElement(components_3.H3, null, title), react_1["default"].createElement(components_1.Paragraph, {
    size: Paragraph_1.Sizes.HELPER
  }, label)))), react_1["default"].createElement(exports.CardBody, null, react_1["default"].createElement(components_1.Paragraph, null, description), react_1["default"].createElement(components_2.Button, {
    look: Button_1.Looks.SECONDARY,
    to: linkUrl
  }, ctaText)));
};

exports.CardWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: white;\n  width: 100%;\n  max-width: 380px;\n  height: 575px !important;\n  box-shadow: 3px 10px 16px 0 rgba(193, 193, 193, 0.45);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  &:hover {\n    transform: translateY(-8px);\n    box-shadow: 3px 10px 40px 0 rgba(193, 193, 193, 0.45);\n  }\n  box-sizing: border-box;\n"], ["\n  background: white;\n  width: 100%;\n  max-width: 380px;\n  height: 575px !important;\n  box-shadow: 3px 10px 16px 0 rgba(193, 193, 193, 0.45);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  &:hover {\n    transform: translateY(-8px);\n    box-shadow: 3px 10px 40px 0 rgba(193, 193, 193, 0.45);\n  }\n  box-sizing: border-box;\n"])));
exports.CardHeader = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 40% !important;\n"], ["\n  height: 40% !important;\n"])));
exports.BackgroundOverlay = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: linear-gradient(\n    rgba(255, 255, 255, 0.5),\n    rgba(255, 255, 255, 0.8)\n  );\n  height: 100%;\n  padding: 32px 23px;\n  box-sizing: border-box;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  h3 {\n    margin-bottom: 6px;\n  }\n  p {\n    margin: 0;\n  }\n"], ["\n  background: linear-gradient(\n    rgba(255, 255, 255, 0.5),\n    rgba(255, 255, 255, 0.8)\n  );\n  height: 100%;\n  padding: 32px 23px;\n  box-sizing: border-box;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  h3 {\n    margin-bottom: 6px;\n  }\n  p {\n    margin: 0;\n  }\n"])));
exports.CardBody = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 32px 23px;\n  height: 60%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  @media (max-width: 639px) {\n    p {\n      text-overflow: ellipsis;\n    }\n  }\n  a {\n    justify-self: flex-end;\n    align-self: flex-start;\n    margin: 0;\n    flex-shrink: 0;\n  }\n"], ["\n  padding: 32px 23px;\n  height: 60%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  @media (max-width: 639px) {\n    p {\n      text-overflow: ellipsis;\n    }\n  }\n  a {\n    justify-self: flex-end;\n    align-self: flex-start;\n    margin: 0;\n    flex-shrink: 0;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;